import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=444959c3&scoped=true"
import script from "./UserCenter.vue?vue&type=script&lang=js"
export * from "./UserCenter.vue?vue&type=script&lang=js"
import style0 from "./UserCenter.vue?vue&type=style&index=0&id=444959c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444959c3",
  null
  
)

export default component.exports